const GENDER = {
    MAN: 1,
    WOMAN: 2,
    COUPLE: 3,
    COUPLE_LESBIAN: 4,
    COUPLE_GAY: 5,
    NON_BINARY: 6,
    GUEST: 'guest',
    GROUP: 'group'
};

const GENDER_KEY_BY_VALUE = Object.entries(GENDER).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
}, {});

const GENDER_NAME_LABEL = {
    MAN: 'Homme',
    WOMAN: 'Femme',
    COUPLE: 'Couple',
    COUPLE_LESBIAN: 'Couple lesbien',
    COUPLE_GAY: 'Couple gay',
    NON_BINARY: 'Non-binaire'
};

const GENDER_LABEL = {
    [GENDER.MAN]: GENDER_NAME_LABEL.MAN,
    [GENDER.WOMAN]: GENDER_NAME_LABEL.WOMAN,
    [GENDER.COUPLE]: GENDER_NAME_LABEL.COUPLE,
    [GENDER.COUPLE_LESBIAN]: GENDER_NAME_LABEL.COUPLE_LESBIAN,
    [GENDER.COUPLE_GAY]: GENDER_NAME_LABEL.COUPLE_GAY,
    [GENDER.NON_BINARY]: GENDER_NAME_LABEL.NON_BINARY
};

const CLASS_GENDERS = {
    [GENDER.MAN]: 'gender-man',
    [GENDER.WOMAN]: 'gender-woman',
    [GENDER.COUPLE]: 'gender-couple',
    [GENDER.COUPLE_LESBIAN]: 'gender-couple-lesbian',
    [GENDER.COUPLE_GAY]: 'gender-couple-gay',
    [GENDER.NON_BINARY]: 'gender-non-binaire',
    [GENDER.GUEST]: 'guest',
    [GENDER.GROUP]: 'group'
};

const GENDER_CLASS_LIST = [
  "undefined",
  CLASS_GENDERS[GENDER.MAN],
  CLASS_GENDERS[GENDER.WOMAN],
  CLASS_GENDERS[GENDER.COUPLE],
  CLASS_GENDERS[GENDER.COUPLE_LESBIAN],
  CLASS_GENDERS[GENDER.COUPLE_GAY],
  CLASS_GENDERS[GENDER.NON_BINARY]
];

const GENDER_CLASS_PROFILE = [
  CLASS_GENDERS[GENDER.MAN].replace('gender-', ''),           // "man"
  CLASS_GENDERS[GENDER.WOMAN].replace('gender-', ''),         // "woman"
  CLASS_GENDERS[GENDER.COUPLE].replace('gender-', ''),        // "couple"
  CLASS_GENDERS[GENDER.COUPLE_LESBIAN].replace('gender-', ''),// "couple-lesbian"
  CLASS_GENDERS[GENDER.COUPLE_GAY].replace('gender-', ''),    // "couple-gay"
  CLASS_GENDERS[GENDER.NON_BINARY].replace('gender-', '')     // "non-binaire"
];

const GENDER_LIST = [
  'Non défini',
  GENDER_NAME_LABEL.MAN,
  GENDER_NAME_LABEL.WOMAN,
  GENDER_NAME_LABEL.COUPLE,
  GENDER_NAME_LABEL.COUPLE_LESBIAN,
  GENDER_NAME_LABEL.COUPLE_GAY,
  GENDER_NAME_LABEL.NON_BINARY
];


const LOOKING_FOR_ENUM = {
  UNDEFINED: 0,
  WOMAN_STRAIGHT: 1,
  WOMAN_LESBIAN: 2,
  WOMAN_BI: 3,
  MAN_STRAIGHT: 4,
  MAN_GAY: 5,
  MAN_BI: 6,
  COUPLE_STRAIGHT: 7,
  COUPLE_HOMO: 8,
  COUPLE_LESBIAN: 9,
  COUPLE_WOMAN_BI: 10,
  COUPLE_MAN_BI: 11,
  NON_BINARY: 12
};

const LOOKING_FOR_LABEL = {
  [LOOKING_FOR_ENUM.UNDEFINED]: "Non renseigné",
  [LOOKING_FOR_ENUM.WOMAN_STRAIGHT]: "Femme hétéro",
  [LOOKING_FOR_ENUM.WOMAN_LESBIAN]: "Femme lesbienne",
  [LOOKING_FOR_ENUM.WOMAN_BI]: "Femme bi",
  [LOOKING_FOR_ENUM.MAN_STRAIGHT]: "Homme hétéro",
  [LOOKING_FOR_ENUM.MAN_GAY]: "Homme gay",
  [LOOKING_FOR_ENUM.MAN_BI]: "Homme bi",
  [LOOKING_FOR_ENUM.COUPLE_STRAIGHT]: "Couple hétéro",
  [LOOKING_FOR_ENUM.COUPLE_HOMO]: "Couple homo",
  [LOOKING_FOR_ENUM.COUPLE_LESBIAN]: "Couple lesbien",
  [LOOKING_FOR_ENUM.COUPLE_WOMAN_BI]: "Couple femme bi",
  [LOOKING_FOR_ENUM.COUPLE_MAN_BI]: "Couple homme bi",
  [LOOKING_FOR_ENUM.NON_BINARY]: "Non-binaire"
};

const LOOKING_FOR_LIST = Object.values(LOOKING_FOR_LABEL);

export {
    GENDER,
    GENDER_KEY_BY_VALUE,
    CLASS_GENDERS,
    GENDER_LABEL,
    GENDER_NAME_LABEL,
    GENDER_LIST,
    GENDER_CLASS_LIST,
    GENDER_CLASS_PROFILE,
    LOOKING_FOR_ENUM,
    LOOKING_FOR_LABEL,
    LOOKING_FOR_LIST
};
